import { render, staticRenderFns } from "./EventSetup.vue?vue&type=template&id=1a27aee2&"
import script from "./EventSetup.vue?vue&type=script&lang=js&"
export * from "./EventSetup.vue?vue&type=script&lang=js&"
import style0 from "./EventSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports